import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "c-accordion",
  id: "accordion-collapse",
  "data-accordion": "collapse"
}
const _hoisted_2 = { class: "mb-4 rounded-xl shadow-md" }
const _hoisted_3 = {
  key: 0,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 15l7-7 7 7"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "p-5 font-light border border-gray-200 bg-background-white rounded-b-xl" }
const _hoisted_10 = { class: "mb-2 text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["bg-background-white flex items-center justify-between w-full p-5 font-regular text-left text-xl border border-gray-200 rounded-t-xl", !_ctx.isOpen ? 'rounded-b-xl' : 'rounded-none']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
        }, [
          _createElementVNode("span", null, _toDisplayString($props.title), 1),
          _createElementVNode("span", null, [
            (_ctx.isOpen)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
              : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
          ])
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isOpen ? 'd-block' : 'hidden')
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 2)
    ])
  ]))
}